export default __webpack_public_path__ + "static/media/firebase-firestore.65edfab0.png";